var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"tree-grid-column",style:([_vm.widthStyle])},[_vm._v("\n  "+_vm._s(_vm.title)+"\n  "),_vm._t("item")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2c32a24","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/treegrid/TreeGridColumn.vue
// module id = null
// module chunks = 